/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ue_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free URL encoder and decoder. Percent-encode text for URLs and query strings, or decode them back, with full Unicode support. Runs in your browser.`)
};

const es_ue_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificador y decodificador de URL gratuito. Codifica texto en porcentaje para URL y cadenas de consulta, o decodifícalas, con soporte completo de Unicode. Se ejecuta en tu navegador.`)
};

const de_ue_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser URL-Kodierer und Dekoder. Kodieren Sie Text mit Prozentzeichen für URLs und Query Strings, oder dekodieren Sie sie zurück, mit vollständiger Unicode-Unterstützung. Läuft in Ihrem Browser.`)
};

const nl_ue_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis URL-encoder en -decoder. Percent-codeer tekst voor URL's en querystrings, of decodeer deze terug, met volledige Unicode-ondersteuning. Werkt in uw browser.`)
};

const fr_ue_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encodeur et décodeur URL gratuit. Encodez le texte en pourcentage pour les URL et les chaînes de requête, ou décodez-les, avec support Unicode complet. S'exécute dans votre navigateur.`)
};

const it_ue_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificatore e decodificatore URL gratuito. Codifica in percentuale il testo per gli URL e le stringhe di query, o decodifica gli URL codificati con il supporto Unicode completo. Viene eseguito nel browser.`)
};

const pt_br2_ue_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificador e decodificador de URL gratuito. Codifique por porcentagem texto para URLs e strings de consulta, ou decodifique-os, com suporte Unicode completo. Executado no seu navegador.`)
};

const pt_ue_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificador e descodificador de URL gratuito. Codifique em percentual o texto para URLs e strings de consulta, ou descodifique-o de volta, com suporte completo a Unicode. Funciona no seu navegador.`)
};

const ja_ue_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のURLエンコーダーとデコーダー。テキストをパーセント エンコードしてURLとクエリ文字列に対応させるか、デコードして元に戻します。完全なUnicode サポート付き。ブラウザで実行されます。`)
};

const zh_ue_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的 URL 编码器和解码器。为 URL 和查询字符串对文本进行百分号编码，或将其解码回原文，支持完整的 Unicode。在你的浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ue_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ue_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ue_tool_description", locale)
	if (locale === "en") return en_ue_tool_description(inputs)
	if (locale === "es") return es_ue_tool_description(inputs)
	if (locale === "de") return de_ue_tool_description(inputs)
	if (locale === "nl") return nl_ue_tool_description(inputs)
	if (locale === "fr") return fr_ue_tool_description(inputs)
	if (locale === "it") return it_ue_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_ue_tool_description(inputs)
	if (locale === "pt") return pt_ue_tool_description(inputs)
	if (locale === "ja") return ja_ue_tool_description(inputs)
	return zh_ue_tool_description(inputs)
};